'use client'

import React, { useState } from 'react';
import { Edit2, Save, X } from 'lucide-react';
import { updateBiography } from '@/actions/updateBio';

export function BioEditor({ userId, initialBio, isOwner }: { userId: string, initialBio: string, isOwner: boolean }) {
    const [isEditing, setIsEditing] = useState(false);
    const [bio, setBio] = useState(initialBio);
    const [tempBio, setTempBio] = useState(initialBio);

    const handleSave = async () => {
        await updateBiography(userId, tempBio);
        setBio(tempBio);
        setIsEditing(false);
    };

    return (
        <section>
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-sm font-bold uppercase tracking-[0.2em] text-amber-900 font-sans">User Biography</h2>
                {isOwner && !isEditing && (
                    <button onClick={() => setIsEditing(true)} className="text-amber-700 hover:text-amber-900 flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest">
                        <Edit2 size={14} /> Edit
                    </button>
                )}
            </div>
            <div className="bg-white border border-amber-100 p-8 rounded-xl shadow-sm">
                {isEditing ? (
                    <div className="space-y-4">
                        <textarea 
                            value={tempBio}
                            onChange={(e) => setTempBio(e.target.value)}
                            className="w-full p-4 border border-amber-200 rounded-lg font-serif text-slate-700 h-32 outline-none focus:ring-1 focus:ring-amber-500"
                        />
                        <div className="flex justify-end gap-3">
                            <button onClick={() => setIsEditing(false)} className="p-2 text-slate-400"><X size={20}/></button>
                            <button onClick={handleSave} className="bg-amber-800 text-white px-4 py-2 rounded text-xs font-bold uppercase tracking-widest flex items-center gap-2">
                                <Save size={14}/> Save Biography
                            </button>
                        </div>
                    </div>
                ) : (
                    <p className="text-slate-700 font-serif leading-loose italic">
                        {bio || "This member has not yet provided a public bio."}
                    </p>
                )}
            </div>
        </section>
    );
}